export default (ctx, html) => html`
  ${ctx.roles.map((role, index) => html`
    <button class="${ctx['item-class']}" @click="${(e) => ctx.switchRole(e, role)}" ?disabled="${role.$active}" data-bi-id="nav_switch_role_${role.id}">
      ${role.group_name}
    </button>
  `)}

  <template class="d-none dropdown-item menu-link btn btn-block text-left"></template>
`;
